/**
 * @generated SignedSource<<4d466ced8030e3df94adbf58018f4cff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type KPITeamScreenSubscription$variables = {
  routineIds: ReadonlyArray<string>;
};
export type KPITeamScreenSubscription$data = {
  readonly routineTaskExecutionChanged: {
    readonly formattedNumberValue?: string | null;
    readonly id: string;
    readonly isCompleted?: boolean;
    readonly numberValue?: number | null;
  } | null;
};
export type KPITeamScreenSubscription = {
  response: KPITeamScreenSubscription$data;
  variables: KPITeamScreenSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "routineIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "routineIds",
    "variableName": "routineIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCompleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedNumberValue",
      "storageKey": null
    }
  ],
  "type": "TaskExecutionNumber",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "KPITeamScreenSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "routineTaskExecutionChanged",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "KPITeamScreenSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "routineTaskExecutionChanged",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b78b280930837056cf0923448918de2a",
    "id": null,
    "metadata": {},
    "name": "KPITeamScreenSubscription",
    "operationKind": "subscription",
    "text": "subscription KPITeamScreenSubscription(\n  $routineIds: [ID!]!\n) {\n  routineTaskExecutionChanged(routineIds: $routineIds) {\n    __typename\n    id\n    ... on TaskExecutionNumber {\n      isCompleted\n      numberValue\n      formattedNumberValue\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0c8140c6a5861a6588616a2bd223fbdb";

export default node;
